import { useApolloClient } from "@apollo/client"
import { Position } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import ActionMenu from "components/Organisms/ActionMenu"
import ActionMenuItem from "components/Organisms/ActionMenuItem"
import links from "constants/links"
import {
  OrderInvoiceDetailQuery,
  OrderInvoiceDetailQueryVariables,
} from "generated/graphql"
import { PRINT_ORDER_INVOICE } from "graphql/order/order.queries.gql"
import useAuth from "hooks/useAuth"
import React, { useState } from "react"
import useAxios from "services/axios.service"
import AppToaster from "utils/AppToaster"

type DownloadOrderInvoiceProps = {
  orderId: string
  billingDocs?: Record<string, any>[]
}

const DownloadOrderInvoice = ({
  orderId,
  billingDocs,
}: DownloadOrderInvoiceProps) => {
  const axios = useAxios()
  const client = useApolloClient()
  const me = useAuth()
  const invoiceType = me.user?.currentDepartment?.invoiceType
  const [printLoading, setPrintLoading] = useState(false)
  const isLoading = printLoading
  const downloadInvoice = async (billingDocId?: string) => {
    setPrintLoading(true)
    const { data } = await client.query<
      OrderInvoiceDetailQuery,
      OrderInvoiceDetailQueryVariables
    >({
      query: PRINT_ORDER_INVOICE,
      variables: {
        orderId,
      },
    })
    if (!data) return
    const invoicePath = data.orderInvoiceDetail.invoiceDocumentPath

    try {
      if (!invoicePath) {
        throw new Error("Invoice does not exist for this order")
      }
      const response = await axios.get(`${links.INVOICE}${invoicePath}`, {
        params: {
          doc: billingDocId,
        },
        responseType: "blob",
      })
      const fileURL = URL.createObjectURL(response.data)
      window.open(fileURL, "_blank")
    } catch (error) {
      AppToaster.show({
        message: error.message,
        intent: "danger",
      })
    } finally {
      setPrintLoading(false)
    }
  }

  return (
    <>
      {billingDocs?.length && invoiceType !== "VTIN" ? (
        <ActionMenu
          text="Invoices"
          popoverProps={{
            position: Position.BOTTOM_RIGHT,
            portalClassName: "vt-modal-portal",
          }}
          onClick={docId => downloadInvoice(docId)}
          loading={isLoading}
          icon="print"
          rightIcon="caret-down"
          small
        >
          {billingDocs.map(doc => {
            const id = doc?.id
            return (
              <ActionMenuItem
                disabled={isLoading}
                id={id}
                icon="download"
                text={<span>Doc {doc?.billingDocNumber}</span>}
              />
            )
          })}
        </ActionMenu>
      ) : null}

      {invoiceType === "VTIN" || invoiceType === "SPBD" ? (
        <CustomButton onClick={() => downloadInvoice()} small icon="print">
          Download Invoice
        </CustomButton>
      ) : null}
    </>
  )
}

export default DownloadOrderInvoice
